var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"duration"}},[_c('font-awesome-icon',{attrs:{"icon":"times-circle","size":"1x"}}),_vm._v("  "),_c('strong',[_vm._v(_vm._s(_vm.repetitions)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }